import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { autoRemove: Boolean, default: false };

  declare autoRemoveValue: boolean;

  timeout: ReturnType<typeof setTimeout> | null = null;

  connect() {
    if (this.autoRemoveValue) {
      this.startTimer();
    }
  }

  disconnect() {
    this.stopTimer();
  }

  startTimer() {
    this.stopTimer();
    this.timeout = setTimeout(() => {
      this.close();
    }, 5000);
  }

  stopTimer() {
    if (this.timeout) {
      clearTimeout(this.timeout);
      this.timeout = null;
    }
  }

  close() {
    this.element.remove();
  }

  handleMouseEnter() {
    this.stopTimer();
  }

  handleMouseLeave() {
    if (this.autoRemoveValue) {
      this.startTimer();
    }
  }
}
